module.exports = __webpack_public_path__ + "media/images/ticket/back_to_cart-cada6d866028b4f6d1d7be8a0d33f9f4.png";